import React from 'react';

import { saveAs as saveAsFile } from 'file-saver';
import DownloadIcon from 'icons/ic-download.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import OutlinedButton from 'components/application/buttons/OutlinedButton';

export default function Download({ buttonText, disabled, filename, hashid }) {
  const { t: i18nTAttachments } = useTranslation('common', {
    keyPrefix: 'attachments',
  });

  const handleClick = () => {
    saveAsFile(`/attachments/${hashid}/download`, filename);
  };

  return (
    <OutlinedButton
      color='grey'
      disabled={disabled}
      onClick={handleClick}
      size='sm'
    >
      <DownloadIcon className='-tw-ml-2' height={24} width={24} />
      <span>{buttonText || i18nTAttachments('downloadOriginal')}</span>
    </OutlinedButton>
  );
}

Download.propTypes = {
  buttonText: PropTypes.string,
  filename: PropTypes.string.isRequired,
  hashid: PropTypes.string.isRequired,
};
